const WebSocket = require('./webSocket')
const dataManager = require('./dataManager')

class App {
    eventListeners = {}

    constructor() {
        if (!this.auth()) return

        this.data = new dataManager()
        this.webSocket = new WebSocket('dashboard')
        this.webSocket.connect()
        this.webSocket.on('message', this.handleMessage.bind(this))
        this.webSocket.on('unauthorized', () => {
            this.auth()
        })
        this.simpleRoute()
        //this.webSocket.sendMessage({type:"getDevices"});
    }

    on(event, callback) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = []
        }
        this.eventListeners[event].push(callback)
    }

    emit(event, data) {
        if (this.eventListeners[event]) {
            this.eventListeners[event].forEach((callback) => callback(data))
        }
    }

    handleMessage(msg) {
        console.log('Received message:', msg)

        if (!msg.action || !msg.type || !msg.data) {
            console.log('corrupted message', msg)
            return
        }

        switch (msg.action) {
            case 'update':
                this.data.set(msg.type, msg.data)
                this.emit('dataUpdate', { type: msg.type, data: msg.data })
                break
            case 'stream':
                this.emit('stream', msg.data)
                break
            case 'delete':
                this.data.delete(msg.type, msg.data)
                break
            case 'user':
                if (msg.data.activeDevices == 0) {
                    this.emit('newUser', { type: msg.type, data: msg.data })
                }
                this.emit('user', { type: msg.type, data: msg.data })
                this.user = msg.data
                break
            default:
                console.log('Unknown action:', msg.action)
                break
        }
    }
    isAuth() {
        return document.cookie.split(';').some((item) => item.trim().startsWith('X-Auth-Token='))
    }
    auth() {
        if (!this.isAuth()) {
            window.location.href = '/login.html?redirectUrl=' + encodeURIComponent(window.location.href)
            return false
        }
        return true
    }

    simpleRoute() {
        history.replaceState({ page: 0 }, 'Dashboard', '#/dashboard/' + history.length)
        history.pushState({ page: 1 }, 'Devices', '#/devices/')
        window.addEventListener(
            'hashchange',
            (e) => {
                let hs = history.state
                let dir = 1
                console.log('The hash has changed!', e.newURL + ' ' + e.oldURL, hs)
                if (e.oldURL.includes('device/') && !e.newURL.includes('cast/')) {
                    dir = 0
                    console.log('#HIST clcbck for device', hs)
                    let btn = document.querySelector('#device-profile .back-button')
                    if (btn) {
                        btn.click()
                    }
                } else if (e.oldURL.includes('cast/')) {
                    dir = 0
                    console.log('#HIST clcbck for cast', hs)
                    let btn = document.querySelector('.cast_container .close_button')
                    if (btn) {
                        btn.click()
                    }
                }
                if (dir && hs && hs.action && hs.action === 'click') {
                    console.log('going to click', hs)
                    if (hs.target && document.querySelector(hs.target)) {
                        console.log('click on target', hs.target)
                        document.querySelector(hs.target).click()
                    }
                }
            },
            false
        )
    }
}

module.exports = new App()
